import { setPageDetails } from '../analytics';
var BASE = 'account>guest order tracking';
var MAML = 'maml:guest order tracking';
var MY_ACCOUNT = 'account';
/**
 * Page analtyics for Guest Order Tracking
 */
export var setGuestOrderTrackingPageAnalytics = function () {
    var linkedAccountsPageData = {
        pageInfo: {
            pageName: BASE,
            pageType: MAML,
        },
        category: {
            primaryCategory: MY_ACCOUNT,
            subCategory1: BASE,
            subCategory2: BASE,
        },
    };
    setPageDetails(linkedAccountsPageData);
};
